import { useState } from "react";

import { Button, makeStyles } from "@material-ui/core";

import CreateTwilioConfig from "./CreateTwilioConfig";
import ImportTwilioConfig from "./ImportTwilioConfig";

const useStyles = makeStyles(() => ({
  button: {
    marginRight: "15px"
  }
}));

export default function AddTwilioWrapper(): JSX.Element {
  const [inputTwilioConfigDialogOpen, toggleInputTwilioConfigDialog] =
    useState(false);
  const [addTwilioConfigDialogOpen, toggleAddTwilioConfigDialog] =
    useState(false);

  const classes = useStyles();

  return (
    <>
      <Button
        className={classes.button}
        onClick={() => toggleAddTwilioConfigDialog(true)}
        color="primary"
        variant="contained"
      >
        + Create New Twilio Subaccount
      </Button>
      <Button
        onClick={() => toggleInputTwilioConfigDialog(true)}
        color="primary"
        variant="contained"
      >
        + Import Existing Twilio Subaccount
      </Button>
      <CreateTwilioConfig
        open={addTwilioConfigDialogOpen}
        onClose={() => toggleAddTwilioConfigDialog(false)}
      />
      <ImportTwilioConfig
        open={inputTwilioConfigDialogOpen}
        onClose={() => toggleInputTwilioConfigDialog(false)}
      />
    </>
  );
}
